import React from 'react'
import InvOptimizationPage from './InvOptimizationsPage'

const InvOptimization = () => {
  return (
    <div>
      <InvOptimizationPage />
    </div>
  )
}

export default InvOptimization